var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14.4,
    viewBox: "0 0 24 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "language-solid",
    d: "M0,66.4A2.4,2.4,0,0,1,2.4,64H21.6A2.4,2.4,0,0,1,24,66.4V76a2.4,2.4,0,0,1-2.4,2.4H2.4A2.4,2.4,0,0,1,0,76Zm12,0V76h9.6V66.4ZM6.686,68.2a.751.751,0,0,0-1.373,0l-2.4,5.4a.75.75,0,0,0,1.373.607l.334-.754H7.38l.334.754A.75.75,0,0,0,9.086,73.6l-2.4-5.4ZM6,70.345l.712,1.6H5.287Zm10.8-2.6a.752.752,0,0,1,.75.75v.15H19.8a.75.75,0,0,1,0,1.5h-.075l-.06.169a7.376,7.376,0,0,1-1.485,2.452c.034.023.068.041.1.06l.709.424a.749.749,0,1,1-.769,1.286l-.709-.424c-.169-.1-.33-.206-.491-.319a7.479,7.479,0,0,1-1.275.728l-.135.06A.75.75,0,1,1,15,73.214l.135-.06a5.83,5.83,0,0,0,.694-.367l-.458-.458a.75.75,0,0,1,1.061-1.061l.548.548.019.019a5.879,5.879,0,0,0,1.117-1.687H14.1a.75.75,0,1,1,0-1.5h1.95V68.5a.752.752,0,0,1,.75-.75Z",
    transform: "translate(0 -64)",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.88dbc091f4648f9e1efd66c8dbf82953.svg";
export { ForwardRef as ReactComponent };